<template>
  <div class='container'>
    <div class="top-bar">
      <div class="examine_btn" :class="{'active_btn':activeBtn}" @click="handleExamine(1)">审核</div>
      <div class="examine_btn" :class="{'active_btn':!activeBtn}" @click="handleExamine(0)">反审核</div>
    </div>

    <div class="middle-wrap" style="margin: 20px 0;">
      <div>
        时间：
        <el-date-picker
          v-model="year"
          type="year"
          size="small"
          style="width:130px"
          placeholder="选择年"
          :clearable="true"
          :picker-options="pickerBeginDateBefore"
          @change="changeYear">
        </el-date-picker>
      </div>
      <div class="mid-right">
        <el-button size="small" v-if="activeBtn" @click="handleBatch(1)">批量驳回</el-button>
        <el-button size="small" @click="handleBatch(2)">批量{{ activeBtn ? '通过' : '反审核' }} </el-button>
      </div>
    </div>

    <!-- 编辑器  后期可移植到弹框-->
    <div style="margin-top: 20px;">
      <!-- <MkEditor/> -->
      <!-- 审核详情 -->
      <ExamineDetail
        ref="ExamineDetail"
        @examineOperate="examineOperate"
        @tableSelection="list => selectionList = list" />
    </div>

    <!-- 驳回详情 -->
    <RejectDetail ref="RejectDetail" @rejectConfirm="rejectConfirm" />
  </div>
</template>

<script>
import RejectDetail from "./components/RejectDetail"
import ExamineDetail from './components/ExamineDetail'
// import MkEditor from "../../components/mk-editor/Editor.vue"
import { examinePass } from '@/api'
export default {
  components:{ ExamineDetail,RejectDetail },
  props:{},
  created() {
    // this.$nextTick(() => {
    //   this.handleExamine(1)
    // })
    this.getAccountPeriods()
  },
  activated() {
    let accountInfo = this.$getSessionStorage('accountInfo')
    this.year = accountInfo.yearPeriodTimeStamp
    this.handleExamine(1)
  },
  computed: {
		// 获取会计期间开始时间
		getAccountPeriod() {
			return this.$store.state.accountInfo.yearPeriods;
		},
  },
  data() {
    return {
      activeBtn: 1,
      year: '',
      selectionList: [],
      pickerBeginDateBefore: {
        disabledDate: (time) => {
          let res = this.$store.state.accountInfo.yearPeriods;
          let beginStartDateVal = res.startTimeStamp;
          let beginEndDateVal = res.endTimeStamp;
          if (beginEndDateVal && beginEndDateVal) {
            return time.getTime() > beginEndDateVal || time.getTime() < beginStartDateVal
          }
        }
      },
    }
  },
  methods:{
    handleExamine(type = this.activeBtn) {
      this.activeBtn = type
      this.$refs.ExamineDetail.handleOpen(type,this.year)
    },
    // 批量操作
    handleBatch(type) {
      if(!this.selectionList.length) { return this.$message.error('请至少选择一条数据！') }
      this.examineOperate(this.selectionList,type)
    },
    // 表格操作
    examineOperate(rows,type) { // type 1驳回 2通过
      const ret = Array.isArray(rows) ? rows : [rows]
      if(type == 1) {
        this.$refs.RejectDetail.handleOpen(ret)
      }else if(type == 2) {
        this.handleExaminePass(ret)
      }
    },
    // 驳回确定
    rejectConfirm() {
      this.handleExamine()
    },
    // 通过确定
    handleExaminePass(list) {
      let str = this.activeBtn ? '确认审核通过' : '反审核会将审核状态恢复为待审核'
      this.$confirm(`${str}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await examinePass({
          cid: JSON.parse(sessionStorage.getItem("cid")),
          ids: list.map(x => x.id).join(','),
          deApproval: !!!this.activeBtn
        })
        if(data.code == 1) {
          this.$message.success(`${this.activeBtn ? '' : '反'}审核成功`)
          this.handleExamine()
        }
      })
    },
    changeYear() {
      this.handleExamine(this.activeBtn)
    },
    // 获取会计期间/初始化数据
		getAccountPeriods() {
			if(!this.getAccountPeriod) {
				this.$store.dispatch('getAllYearPeriodsData')
			}
		},
  },
}
</script>

<style lang='less' scoped>
.container {
  height: 100%;
  background-color: white;
  padding: 20px;
  box-sizing: border-box;
  .top-bar {
    display: flex;
    .examine_btn {
      width: 100px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      background: #ffffff;
      border-radius: 5px;
      color: rgb(0, 0, 0);
      border: 1px solid #E9E9E9;
      cursor: pointer;
      &:first-child {
        margin-right: 20px;
      }
      &:hover {
        filter: brightness(95%);
      }
    }
    .active_btn {
      border: 1px solid #269D7B !important;
      background: #269D7B !important;
      color: white !important;
    }
  }
  .middle-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/examine/examine.vue